
import {CREATE_BREED_CATEGORY ,
  UPDATE_BREED_CATEGORY ,
    DELETE_BREED_CATEGORY ,
    FETCH_BREED_CATEGORIES } from '../actions';

const initialState = {
  selectedToDelete: null,
  selectedToEdit: null,
  setBreedCategory : null ,
  updateBreedCategory : null,
  breedCategories: [],
  loading: false, 
  updateBreedCategoryError : null,
  setBreedCategoryError : null,
  breedCategoriesError : null,
  selectedToDeleteError : null,
};

function breedCategoryReducer(state = initialState, action) {
  let selectedToDelete,
    breedCategories,
    updateBreedCategory,
    setBreedCategory;

  switch (action.type) {
    case `${CREATE_BREED_CATEGORY}_PENDING`:
    case `${UPDATE_BREED_CATEGORY}_PENDING`:  
    case `${FETCH_BREED_CATEGORIES}_PENDING`:
    case `${DELETE_BREED_CATEGORY}_PENDING`:
      return { ...state, loading: true,
        selectedToDeleteError : null,
        breedCategoriesError : null,
        setBreedCategoryError : null,
        updateBreedCategoryError : null,
      };
     

    case `${CREATE_BREED_CATEGORY}_FULFILLED`:
        setBreedCategory = action.payload.data;
        return { ...state, loading: false, setBreedCategory };
    case `${UPDATE_BREED_CATEGORY}_FULFILLED`:
        updateBreedCategory = action.payload.data;
        return { ...state, loading: false, updateBreedCategory }; 
    case `${FETCH_BREED_CATEGORIES}_FULFILLED`:
        breedCategories = action.payload.data;
        return { ...state, loading: false, breedCategories };

    case `${DELETE_BREED_CATEGORY}_FULFILLED`:
      selectedToDelete = action.payload.data;
      return { ...state, loading: false, selectedToDelete }; 
    case `${CREATE_BREED_CATEGORY}_REJECTED`:
      return {...state, loading: false, setBreedCategoryError: action.payload.response.data, state: initialState };
    case `${UPDATE_BREED_CATEGORY}_REJECTED`:
      return {...state, loading: false, updateBreedCategoryError: action.payload.response.data, state: initialState };
    case `${FETCH_BREED_CATEGORIES}_REJECTED`:
      return {...state, loading: false, breedCategoriesError: action.payload.response.data, state: initialState };
    case `${DELETE_BREED_CATEGORY}_REJECTED`:
      return {...state, loading: false, selectedToDeleteError: action.payload.response.data, state: initialState };

    default:
      return state;
  }
}

export default breedCategoryReducer;
